import React from 'react';
import I18n from 'i18n-js';

import { RCMenu } from '@reverbdotcom/cadence/components';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';

import URLHelpers from '../../shared/url_helpers';
import Location from '../../../lib/wrapped_location';

interface IListingStateProps {
  listing: Listing;
}

export const COMPONENT_NAME = 'EditButton';

function EditButton({ listing }: IListingStateProps) {

  const sellFormEditListingPath = URLHelpers.sellFormEditListingPath(listing.id, {
    section: 'review',
  });

  return (
    <RCMenu.Item onClick={() => {
      trackEvent({
        eventName: MParticleEventName.ClickedComponent,
        componentName: COMPONENT_NAME,
        listingId: listing.id,
      });
      Location.assign(sellFormEditListingPath);
    }}>
      {I18n.t('discovery.listingsManagement.sellerListingCard.edit')}
    </RCMenu.Item>
  );
}

export default EditButton;
